<template>
  <div class="section__lk-menu-mobile d-sm-none">
    <div class="toggle"></div>
    <template v-if="$route.name === 'Selection'">
      <span><icon-attestation fill="#fff" /> Отбор в тренеры</span>
    </template>
  </div>
</template>

<script>
import roleRoutersMixin from "@/mixins/roleRoutersMixin";
import IconAttestation from "@/components/icons/IconAttestation.vue";

export default {
  name: "ProfileMenuUserMobile",
  components: {IconAttestation},
  mixins: [roleRoutersMixin]
}
</script>

<style scoped>

</style>